// import { ResourceInfo } from "../resource-service/entity/ResourceEntity";
// import { ProcessWorkspaceRulesResult } from "./entity/ProcessWorkspaceRulesResult";

export const TokenIBookingService = "IBookingService";

export interface IBookingService {
  // ProcessWorkspaceRules(selectedRs: Array<ResourceInfo>): Promise<ProcessWorkspaceRulesResult>;
  // IsShownDeadlineMessage: boolean;

}
